<template>
  <div
    v-if="
      $store.state.userDetails.role.toLowerCase() == 'superadmin' &&
        (emailValidationAlert == true || showMember == true || showAttendanceL == true)
    "
  >
    <v-carousel :show-arrows="false" :horizontal="true" height="150" hide-delimiter-background>
      <v-carousel-item v-if="showAttendanceL == true">
        <v-flex xs12 sm12 md12>
          <v-card
            v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
            color="primary"
            height="150"
            dark
          >
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <div class="col-100">
                <h2 color="white">Hey {{ $store.state.userDetails.firstName }}!</h2>
              </div>
              <div class="col-100">
                <h4>Now let's punch in by clicking the green "IN" button.</h4>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-carousel-item>
      <v-carousel-item v-if="emailValidationAlert == true">
        <v-flex xs12 sm12 md12>
          <v-card
            v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
            color="primary"
            height="200"
            dark
          >
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <div class="col-100"><h2>You've Got Mail</h2></div>
              <div class="col-100"><h4>Please confirm your organisation’s email</h4></div>
              <div class="col-100">
                <v-btn
                  v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                  @click="resendConfirm"
                  color="primary--text"
                  style="background-color: white;"
                  >Resend</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-carousel-item>
      <v-carousel-item v-if="showMember == true">
        <v-flex xs12 sm12 md12>
          <v-card
            v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
            color="primary"
            height="150"
            dark
          >
            <v-card-title>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
              <div class="col-100">
                <h2>It's Lonely</h2>
              </div>
              <div class="col-100"><h4>Lets add some members</h4></div>
              <div class="col-100">
                <v-btn
                  v-if="$store.state.userDetails.role.toLowerCase() == 'superadmin'"
                  @click.native="$router.replace({ name: 'Members' })"
                  small
                  color="primary--text"
                  style="background-color: white;"
                  >Add Member</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { EventBus } from "@/utilities/event-bus.js";
export default {
  name: "VBanner",
  props: {
    renderedData: {
      type: Array
    }
  },

  data() {
    return {
      //  emailValidationAlert: false
      showMember: true,
      showAttendanceL: true
      //usersAllAttendance: []
    };
  },
  computed: {
    emailValidationAlert() {
      try {
        var company = this.$store.getters.company;
        if (!company.emailVerified) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    }
  },
  watch: {
    showAttendanceL(oldV, newV) {
      console.log("Val change", oldV, newV);
    }
  },
  created() {
    // this.allMembers()
    // this.usersAllAttendance()

    var company = this.$store.getters.company;

    this.checkMemberCount();
    this.checkAttendanceCount();

    console.log("company.emailVerified", company);

    EventBus.$on("updateMemberCount", this.checkMemberCount);
    EventBus.$on("updateAttendanceCount", this.checkAttendanceCount);
  },
  methods: {
    checkAttendanceCount() {
      const self = this;

      try {
        this.$http
          .get(
            `${this.$store.state.endpoint}attendances/count?where[userId]=${this.$store.state.userDetails.id}`
          )
          .then(response => {
            if (Number(response.body.count) < 1) {
              self.showAttendanceL = true;
              console.log("Setting attendance to true");
            } else {
              console.log("Setting attendance to false");
              self.showAttendanceL = false;
            }
          });
      } catch (error) {
        console.log(error);
        console.log("Setting attendance to false error");
        self.showAttendanceL = false;
      }
    },
    checkMemberCount() {
      const self = this;
      this.$http
        .get(
          `${this.$store.state.endpoint}Accounts/count?where[companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(response => {
          console.log("Member count", response.body.count);
          if (Number(response.body.count) < 2) {
            self.showMember = true;
          } else {
            self.showMember = false;
          }
          console.log("Showing members ", self.showMember);
        });
    },

    home() {
      window.location.href = "/";
    },
    resendConfirm() {
      const self = this;
      this.$http
        .post(`${this.$store.state.endpoint}Accounts/sendValidation`, {
          email: self.$store.state.userDetails.email
        })
        .then(response => {
          var msg =
            "Confirmation email sent to " +
            self.$store.state.userDetails.email +
            ". Please check your inbox.";

          this.$swal({
            type: "success",
            text: msg
          });
        });
    },
    emailValidationAlert() {
      try {
        var company = this.$store.getters.company;

        console.log("company.emailVerified", company);

        if (!company.emailVerified) {
          //  return true;
        } else {
          // return false;
        }
      } catch (e) {
        console.log(e);
        // return false;
      }
    }
  }
};
</script>

<style scoped>
.customRoundedNumber {
  height: 32px;
  width: 35px;
  background-color: #5dc3f8;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
}
</style>
